// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.App-logo {
  height: 10vmin;
  pointer-events: none;
}
.buttons button {
  margin-left: 0.5rem;
  padding: 0.5rem 1rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.card {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  align-items: center;
}

.card-left, .card-right {
  flex: 1 1;
  padding-right: 1rem;
}

.card-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.card-h {
    display: flex; /* La magia: allinea i figli (img e content) in orizzontale */
    
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden; /* Nasconde i bordi dell'immagine che escono */
    border: 1px solid #e0e0e0;
  }

.slider {
  display: flex;
  overflow-x: auto;
  gap: 0.5rem;
  max-width: 300px;
}

.slider img {
  height: 120px;
  object-fit: cover;
  border-radius: 6px;
}

.card-left h2 a {
  text-decoration: none;
  color: #1d4ed8;
}

.card-left .address {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 0.25rem;
  align-items: center;
}

.card-right ul {
  list-style-type: disc;
  padding-left: 1.25rem;
}

.card-right ul li a {
  text-decoration: none;
  color: #1e40af;
}

.card-blue { background-color: #ebf8ff; }
.card-green { background-color: #ecfdf5; }
.card-yellow { background-color: #fef9c3; }
.card-pink { background-color: #fce7f3; }
.card-purple { background-color: #ede9fe; }
.slider-container {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 200px;
  height: 120px;
  overflow: hidden;
  justify-content: center;
}

.slider-button {
  background-color: rgba(255, 255, 255, 0.8);
  border: none;
  font-size: 1.5rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  z-index: 2;
  transition: background-color 0.2s;
}

.slider-button:hover {
  background-color: rgba(255, 255, 255, 1);
}

.slider-button.left {
  position: absolute;
  left: 0;
}

.slider-button.right {
  position: absolute;
  right: 0;
}
.tabella-sottile {
  width: 100%; /* Opzionale: imposta la larghezza della tabella */
  border-collapse: collapse; /* Fondamentale: unisce i bordi delle celle */
}

.tabella-sottile th,
.tabella-sottile td {
  border: 1px solid #ccc; /* Imposta il bordo sottile e grigio */
  padding: 8px; /* Aggiunge spazio interno alla cella */
  text-align: left; /* Allinea il testo a sinistra */
}

.tabella-sottile th {
  background-color: #f4f4f4; /* Colora lo sfondo dell'intestazione */
  font-weight: bold;
}

.App-header {
  background-color: #282c34;
  min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
.App {
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
  padding-left: 20px;
}
form {
  	
 text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  padding-left: 20px;
}

input, select, Select, textarea {
  width: 45%;
  padding: 10px;
  border: 1px solid #282c34;
  border-radius: 5px;
  color: #282c34;
  background: #ffffff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s, box-shadow 0.3s;
}


.radio-container {
  display: flex;
  flex-direction: column;
  align-items: flex-center;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 1px; /* Spazio tra il radio e il testo */
}

button, .custom-buttom {
  background-color: #2951AF;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  border: 5px;
  cursor: pointer;
  transition: background 0.3s;
  width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;IACI,aAAa,EAAE,6DAA6D;;IAE5E,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB,EAAE,8CAA8C;IAChE,yBAAyB;EAC3B;;AAEF;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,aAAa,yBAAyB,EAAE;AACxC,cAAc,yBAAyB,EAAE;AACzC,eAAe,yBAAyB,EAAE;AAC1C,aAAa,yBAAyB,EAAE;AACxC,eAAe,yBAAyB,EAAE;AAC1C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW,EAAE,kDAAkD;EAC/D,yBAAyB,EAAE,6CAA6C;AAC1E;;AAEA;;EAEE,sBAAsB,EAAE,sCAAsC;EAC9D,YAAY,EAAE,uCAAuC;EACrD,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,yBAAyB,EAAE,uCAAuC;EAClE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;CAEC,kBAAkB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8CAA8C;AAChD;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,mCAAmC;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n.App-logo {\n  height: 10vmin;\n  pointer-events: none;\n}\n.buttons button {\n  margin-left: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cards {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.card {\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\n  align-items: center;\n}\n\n.card-left, .card-right {\n  flex: 1;\n  padding-right: 1rem;\n}\n\n.card-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.card-h {\n    display: flex; /* La magia: allinea i figli (img e content) in orizzontale */\n    \n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    overflow: hidden; /* Nasconde i bordi dell'immagine che escono */\n    border: 1px solid #e0e0e0;\n  }\n\n.slider {\n  display: flex;\n  overflow-x: auto;\n  gap: 0.5rem;\n  max-width: 300px;\n}\n\n.slider img {\n  height: 120px;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.card-left h2 a {\n  text-decoration: none;\n  color: #1d4ed8;\n}\n\n.card-left .address {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n  align-items: center;\n}\n\n.card-right ul {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n}\n\n.card-right ul li a {\n  text-decoration: none;\n  color: #1e40af;\n}\n\n.card-blue { background-color: #ebf8ff; }\n.card-green { background-color: #ecfdf5; }\n.card-yellow { background-color: #fef9c3; }\n.card-pink { background-color: #fce7f3; }\n.card-purple { background-color: #ede9fe; }\n.slider-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: 200px;\n  height: 120px;\n  overflow: hidden;\n  justify-content: center;\n}\n\n.slider-button {\n  background-color: rgba(255, 255, 255, 0.8);\n  border: none;\n  font-size: 1.5rem;\n  padding: 0.25rem 0.5rem;\n  cursor: pointer;\n  z-index: 2;\n  transition: background-color 0.2s;\n}\n\n.slider-button:hover {\n  background-color: rgba(255, 255, 255, 1);\n}\n\n.slider-button.left {\n  position: absolute;\n  left: 0;\n}\n\n.slider-button.right {\n  position: absolute;\n  right: 0;\n}\n.tabella-sottile {\n  width: 100%; /* Opzionale: imposta la larghezza della tabella */\n  border-collapse: collapse; /* Fondamentale: unisce i bordi delle celle */\n}\n\n.tabella-sottile th,\n.tabella-sottile td {\n  border: 1px solid #ccc; /* Imposta il bordo sottile e grigio */\n  padding: 8px; /* Aggiunge spazio interno alla cella */\n  text-align: left; /* Allinea il testo a sinistra */\n}\n\n.tabella-sottile th {\n  background-color: #f4f4f4; /* Colora lo sfondo dell'intestazione */\n  font-weight: bold;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 10vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n.App {\n  text-align: left;\n  margin-left: 10px;\n  margin-right: 10px;\n  padding-left: 20px;\n}\nform {\n  \t\n text-align: center;\n  margin-left: 10px;\n  margin-right: 10px;\n  padding-left: 20px;\n}\n\ninput, select, Select, textarea {\n  width: 45%;\n  padding: 10px;\n  border: 1px solid #282c34;\n  border-radius: 5px;\n  color: #282c34;\n  background: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.3s, box-shadow 0.3s;\n}\n\n\n.radio-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-center;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  gap: 1px; /* Spazio tra il radio e il testo */\n}\n\nbutton, .custom-buttom {\n  background-color: #2951AF;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 8px;\n  border: 5px;\n  cursor: pointer;\n  transition: background 0.3s;\n  width: 200px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
